import { getFiveMinutesMock, getNewsMock, shouldUseMock } from './mock';
import { apiCall, baseUrl, extendUrl, catalogPrefix } from './config';

export default {
  fiveMinutes: userId => {
    if (shouldUseMock()) {
      return getFiveMinutesMock();
    }
    return apiCall(
      `${catalogPrefix}${baseUrl}${extendUrl}news?items=10&page=0&lang=it&app_name=S4B&htmlEnabled=true`,
      'GET'
    );
  },
  getNews: ({ userId, itemId }) => {
    if (shouldUseMock()) {
      return getNewsMock();
    }
    return apiCall(
      `${catalogPrefix}${baseUrl}${extendUrl}catalog/detail/news?itemId=${itemId}&htmlEnabled=true`,
      'GET'
    );
  }
};
